// extracted by mini-css-extract-plugin
module.exports = {"title":"youMayAlsoLike_title__2UAA6","main":"youMayAlsoLike_main__2BRGa"};